var {AmpersandView} = require('catalog/libs');

var template = require('../productlist/templates/hpe.productlist.app.template.tpl');
var productCatalogApp = require('../productlist/base/hpe.productlist.app.controller');

/**
 * product list tab view
 */
module.exports = AmpersandView.extend({

    template: template,
    catalogInstance: productCatalogApp.tabInitialize,

    /**
     * render the view and subviews
     */
    render: function() {

        //render the base template with hooks for children
        this.renderWithTemplate(this);

        //Set root element of catalog
        this.catalogInstance.rootElement = document.querySelector('.product-listing-tab');

        //Set tab title prop
        var activeTab = document.querySelector('.dynamic-tab-container-tab.active');
        this.catalogInstance.tabInstanceTitle = activeTab && activeTab.innerHTML || '';

        //Let the app controller know it is embedded in a tab.
        this.catalogInstance.isTabInstance = true;

        //Init Catalog App Instance
        this.catalogInstance.init();

        //Set reference to main catalog model
        this.catalogModel = this.catalogInstance.mainView.model;

        //service url provided by tab structure has selectors representing tab state (used to create service urls)
        if (this.serviceURL) {

            //save initial state
            this.catalogModel.state = this.catalogModel.parseStateString(this.serviceURL);

            //request JSON from server
            this.xhr = this.catalogModel.fetch();
        }

        return this;
    }
});

